import { useEffect, useState } from 'react';
import { NavDropdown } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Logo from "../../Assets/Images/Logo.png";
import { logout } from '../../Redux/Slice/Auth/authSlice';
import { me } from '../../Services/DashboardServices';


const DashboardHeader = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [isScrolled, setIsScrolled] = useState(false)
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(false)
    const user1 = useSelector((state) => state.auth.data);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 2) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    const handleGetUser = async () => {
        setLoading(true)
        const response = await me(user1?.id);
        if (response?.code === 200) {
            setUser(response?.result?.user)
        }
        else {
            setLoading(false)
        }
    }

    useEffect(() => { handleGetUser(); }, [])


    const handleLogout = async () => {
        dispatch(logout());
        navigate('/')
    }


    return (
        <>
            <header
                className={`${!isScrolled
                    ? "header-three header-absolute sticky-header bg-theme"
                    : "header-absolute header-three sticky-header sticky bg-theme "
                    }     d-xl-block d-none`}
            >

                <Navbar expand="lg" className="">
                    <Container>
                        <Navbar.Brand className='text-light fw-bold' as={Link} to="/dashboard">
                            <img src={Logo} alt="" width={150} />
                            {/* Dashboard */}
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll">
                            <Nav
                                className="me-auto my-2 my-lg-0"
                                style={{ maxHeight: '100px' }}
                                navbarScroll
                            >

                            </Nav>

                            <NavDropdown className='text-white' title={user?.name} id="basic-nav-dropdown">
                                <NavDropdown.Item as={Link} to="/dashboard/profile-setting">Profile Setting</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item onClick={handleLogout}>
                                    Logout
                                </NavDropdown.Item>
                            </NavDropdown>

                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </header>


            <Navbar className="bg-theme d-xl-none d-block header-mob">
                <Container>
                    <Navbar.Brand as={Link} to="/dashboard">
                        <img src={Logo} width={100} alt="" />
                    </Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">

                        <NavDropdown className='text-white' title={user?.name} id="basic-nav-dropdown">
                            <NavDropdown.Item as={Link} to="/dashboard/profile-setting">Profile Setting</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item onClick={handleLogout}>
                                Logout
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}


export default DashboardHeader